/** Traductions amazighes (zgh) — complétées par i18n-zgh-gap.ts */
export const zghTranslations: Record<string, string> = {};
